// Libraries
import styled, { css } from 'styled-components'

export const WrapFormContent = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 420px;
  margin: 100px 0 35px 0;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      width: 95%;
      margin: 100px 0 20px 0;
    }
  `}
`;

export const TextDescription = styled.p`
  margin-bottom: 30px;
  text-align: left;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 14px;
  line-height: 19px;
`;